import {API_URL} from "@/resourses/api";
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import LoginPage from '../views/LoginPage.vue'
import {ref} from "vue";


const routes: Array<RouteRecordRaw> = [
  {
    path: '/login',
    name: 'login',
    component: LoginPage,
    meta:{layout: 'empty'}
  },
  {
    path: '/',
    name: 'builder',
    meta: {auth: true},
    component: () => import('../views/MainPage.vue')
  },{
    path: '/toggles',
    name: 'toggles',
    meta: {auth: true},
    component: () => import('../views/TogglesPages.vue')
  },{
    path: '/logs',
    name: 'logs',
    meta: {auth: true},
    component: () => import('../views/LogsPage.vue')
  },{
    path: '/notifications',
    name: 'notifications',
    meta: {auth: true},
    component: () => import('../views/NotificationsPage.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
router.beforeEach((to, from, next)=>{
  const requireAuth = to.matched.some(record => record.meta.auth)
  let authorized = ref(false)

  // if(to.path === '/toggles'){
  //   fetch(`${API_URL}/toggles/users/me`,{credentials: 'include'}).then(result=> {
  //     authorized.value = result.status !== 401 && result.status !== 403
  //     if(requireAuth && !authorized.value) next('/login')
  //     else next()
  //   })
  // }
  // else if(to.path === '/'){
  //   fetch(`${API_URL}/builder/users/me`,{credentials: 'include'}).then(result=> {
  //     authorized.value = result.status !== 401 && result.status !== 403
  //     if(requireAuth && !authorized.value) next('/login')
  //     else next()
  //   })
  // }else next()
  fetch(`${API_URL}/builder/users/me`,{credentials: 'include'}).then(result=> {
        authorized.value = result.status !== 401 && result.status !== 403
        if(requireAuth && !authorized.value) next('/login')
        else next()
      })
})

export default router
